var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaidAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 6C0.666992 2.68629 3.35328 0 6.66699 0H36.667C39.9807 0 42.667 2.68629 42.667 6V36C42.667 39.3137 39.9807 42 36.667 42H6.66699C3.35328 42 0.666992 39.3137 0.666992 36V6Z",
    fill: "#EEEDF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2505 20.9997L21.6672 26.4163L32.5005 15.583",
    stroke: "#2F2B3D",
    strokeOpacity: 0.9,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3638 20.4693C11.0709 20.1765 10.5961 20.1765 10.3032 20.4693C10.0103 20.7622 10.0103 21.2371 10.3032 21.53L11.3638 20.4693ZM15.7198 26.9467C16.0127 27.2396 16.4876 27.2396 16.7805 26.9467C17.0734 26.6538 17.0734 26.1789 16.7805 25.886L15.7198 26.9467ZM21.1365 20.4693C20.8436 20.7622 20.8436 21.2371 21.1365 21.53C21.4294 21.8229 21.9043 21.8229 22.1972 21.53L21.1365 20.4693ZM27.6138 16.1133C27.9067 15.8204 27.9067 15.3456 27.6138 15.0527C27.3209 14.7598 26.8461 14.7598 26.5532 15.0527L27.6138 16.1133ZM10.3032 21.53L15.7198 26.9467L16.7805 25.886L11.3638 20.4693L10.3032 21.53ZM22.1972 21.53L27.6138 16.1133L26.5532 15.0527L21.1365 20.4693L22.1972 21.53Z",
    fill: "#2F2B3D",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaidAmount);
export default __webpack_public_path__ + "static/media/paidAmount.89c751530c1802250dc8c0128061a736.svg";
export { ForwardRef as ReactComponent };